import 'css-chunksrc/client/scenes/resourceActivation/styles.scss';export default {
  "body": "_body_fr43d_1",
  "footer": "_footer_fr43d_8",
  "warning": "_warning_fr43d_17",
  "group": "_group_fr43d_23"
};